import s from './Otoku.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import SubHeader from '../../components/SubHeader/SubHeader';
import { Aside } from '../../components/Aside/Aside';
import { Helmet } from "react-helmet";

const blogs = [
  {
    id: 1,
    title: 'ケアンズ現地でSIMカードを設定すると、とっても便利！【Vodafone編】',
    date: '2019年7月30日',
    category: 'ケアンズで快適に過ごすお得情報',
    comment: '1件のコメント',
    img: 'https://dev.mightyaussie.com/wp-content/uploads/2019/07/sim-vodafone@2x-1-960x530.png',
    body: 'ケアンズで自分のスマホを使いたい！というあなたへ。 でもポケットwifiじゃなくて、スマホひとつでシンプルにしたい、と考えている方向けの情報です。この記事は、S',
    link: '/cairns-otoku/sim-vodafone',
  },
  {
    id: 2,
    title: 'ケアンズ現地のフリーWifiをうまく使おう！フリーWifiの設定方法のご紹介',
    date: '2019年7月30日',
    category: 'お知らせ',
    comment: '1件のコメント',
    img: '	https://dev.mightyaussie.com/wp-content/uploads/2019/07/cairns-free-wifi-960x530.png',
    body: 'ケアンズの無料wifiを活用して、快適に過ごそう！ ケアンズ市内のうち、観光スポットになっている中心地はかなりの範囲で無料wifiが行き届いています。 そのため',
    link: '/cairns-otoku/cairns-free-wifi',
    magazine: false,
    sale: false,
    world: false,
    info: true,
  },
  {
    id: 10,
    title: 'ケアンズ現地でSIMカードを設定すると、とっても便利！【OPTUS編】',
    date: '2019年7月30日',
    category: 'ケアンズで快適に過ごすお得情報',
    comment: '1件のコメント',
    img: '	https://dev.mightyaussie.com/wp-content/uploads/2019/07/sim-optus@2x-1-960x530.png',
    body: 'ケアンズで自分のスマホを使いたい！というあなたへ。 でもポケットwifiじゃなくて、スマホひとつでシンプルにしたい、と考えている方向けの情報です。この記事は、S',
    link: '/cairns-otoku/sim-optus',
    magazine: false,
    sale: false,
    world: false,
    info: true,
  },
  {
    id: 10,
    title: 'ケアンズの最安値ツアーを探すときに気をつけること',
    date: '2019年7月9日',
    category: 'ツアーをお得に探す',
    comment: '',
    img: 'https://dev.mightyaussie.com/wp-content/uploads/2019/07/blog_001@2x-960x530.png',
    body: 'こんにちは！　ジェイさんツアーです。 7月に入り、日本の方が暑い日が出てきているのではないでしょうか？ ケアンズは、朝晩は少しひんやりしてとても過ごしやすい時期',
    link: '/blog/nice/tour-search-kokoroe',
    magazine: false,
    sale: true,
    world: false,
    info: false,
  },
];
const breadcrumbs = [
  { label: 'ホーム ', link: '/' },
  { label: 'ジェイさんブログ', link: '/blog' },
  { label: 'カテゴリー: ケアンズで快適に過ごすお得情報' },
];


const Otoku = () => {
  return (
    <>
          <Helmet>
        <title>ケアンズで快適に過ごすお得情報 – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】</title>
        <meta property="og:title" content="ケアンズで快適に過ごすお得情報 – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】" />
        <meta property="og:url" content={`${process.env.REACT_APP_URL}/category/blog/cairns-otoku`} />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />
      </Helmet>
    <div className={s.root}>
    <SubHeader
      title="カテゴリー: ケアンズで快適に過ごすお得情報"
      breadcrumbs={breadcrumbs}
    />
      <div className={s.flex}>
      <div className={s.blogContainer}>
    {blogs.map((blog) => (
      <a
        key={blog.id}
        href={blog.link}
        className={s.cardLinkWrapper}
        aria-label={blog.title}
      >
        <div className={s.card}>
          <div className={s.cardContent}>
            <h3 className={s.cardTitle}>{blog.title}</h3>
              <div className={s.cardMeta}>
                <span className={s.cardMetaItem}>
                <i className="fa fa-calendar"></i>{blog.date}
                </span>
                <span className={s.cardMetaItem}>
                <i className="fa fa-user"></i>ジェイさんツアー
                </span>
                {blog.magazine && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>ジェイさんマガジン
                  </span>
                )}
                {blog.sale && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>ツアーをお得に探す
                  </span>
                )}
                {blog.world && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>世界遺産の観光スポット
                  </span>
                )}
                {blog.info && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>ケアンズで快適に過ごすお得情報
                  </span>
                )}
              </div>
            <img src={blog.img} alt={blog.title} className={s.cardImage} />
            <p className={s.cardBody}>{blog.body.slice(0, 100)}...</p>
            <div className={s.center}><a className={s.button} href={blog.link}>続きを見る<i class="atbtn__icon atbtn__icon--right fa fa-long-arrow-right"></i></a></div>
          </div>
        </div>
      </a>
    ))}
  </div>
     <Aside/>
      </div>
    </div>
    </>
  );
}

export default Otoku;
